import { CreateLaptopForm } from "@/components/forms/laptops/CreateLaptopForm"
import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/laptops/aanmaken")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper>
      <CreateLaptopForm />
    </ScreenWrapper>
  )
}
